import $ from 'jquery'
import { Core } from "../../../assets/src/scripts/core.js"

export class SliderTestimonials {

  constructor() {
    this.$container = $('.slider-testimonials')
    if (!this.$container.length) {
      return
    }

    this.$modal = this.$container.next('.slider-testimonials-modal')
    this.$player = this.$modal.find('.slider-testimonials-modal-player')

    this.bindEvents()
  }

  bindEvents() {
    this.$container.on('click', '[data-play]', this.handlePlay.bind(this))
    this.$modal.on('click', '.modal-overlay, .modal-close', this.handleClose.bind(this))
    $(document).on('keydown', this.handleKeydown.bind(this))
  }

  /**
   * @param {Event} e
   */
  handlePlay(e) {
    e.preventDefault()

    const $card = $(e.currentTarget).closest('.card-testimonial')
    const $tpl = $card.find('.card-testimonial-video-tpl')

    if (!$tpl.length) return

    // Inject iframe HTML from <template> with autoplay=1
    let playerHtml = $tpl.html()
    playerHtml = playerHtml.replace(
      /(<iframe[^>]+src=")([^"]+)(")/,
      (_, pre, src, post) => {
        const sep = src.includes('?') ? '&' : '?'
        return `${pre}${src}${sep}autoplay=1${post}`
      }
    )

    this.$player.html(playerHtml)
    this.$modal.addClass('open')
    Core.disableBodyScroll()
  }

  /**
   * @param {Event} e
   */
  handleClose(e) {
    e.preventDefault()
    this.$modal.removeClass('open')
    this.$player.empty()
    Core.activeBodyScroll()
  }

  /**
   * @param {KeyboardEvent} e
   */
  handleKeydown(e) {
    if (e.key === 'Escape' && this.$modal.hasClass('open')) {
      this.handleClose(e)
    }
  }

}
